export default __webpack_public_path__ + "static/media/truck-solid.678bc193.svg";